import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { GENDER_MASK_WOMAN } from '@app/core/_models'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faUserTieHair, faUserTieHairLong } from '@fortawesome/pro-light-svg-icons'
import { faUserTieHair as faUserTieHairSolid } from '@fortawesome/pro-solid-svg-icons'
import { faUserTieHairLong as faUserTieHairLongSolid } from '@fortawesome/pro-solid-svg-icons'

import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-admin-link',
    imports: [FaIconComponent, RouterModule, TooltipModule],
    templateUrl: './admin-link.component.html',
    styleUrl: './admin-link.component.scss',
})
export class AdminLinkComponent {
    @Input() gender: number
    public groupIcon = faUserTieHair
    public groupIconSolid = faUserTieHairSolid
    public isHovered = false

    constructor() {}

    ngOnInit(): void {
        if (this.gender & GENDER_MASK_WOMAN) {
            this.groupIcon = faUserTieHairLong
            this.groupIconSolid = faUserTieHairLongSolid
        }
    }
}
